const customEventDefaultInit: EventInit = {
  bubbles: true,
  composed: true,
  cancelable: true,
};

export { customEventDefaultInit };
